import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex bg-red-100 rounded-lg p-2 text-sm contacting-5 font-normal text-gray-800 items-center w-full justify-between"
}
const _hoisted_2 = { class: "flex gap-x-2 items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed, watch } from "vue"
import MarketingPreferencesIcon from "@/components/icons/MarketingPreferencesIcon.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import { useContactsStore } from "@/stores/contacts"
import { Contact } from "@/shared/models/contact"
import { InboxContact } from "@/shared/models/inbox"

interface Props {
    recipients: Contact[] | InboxContact[]
    type: string
    showContactName?: boolean
    showCheckbox?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketingPreferencesWarningComponent',
  props: {
    recipients: {},
    type: {},
    showContactName: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false }
  },
  emits: ["update:sendAnyway"],
  setup(__props: any) {

const contactStore = useContactsStore()



const props = __props

const text = computed(() => (props.type === "sms" ? "Messages Marketing turned Off" : "Emails Marketing turned Off"))

const hasMP = computed(() =>
    props.recipients.some((recipient) => {
        if (recipient?.type !== "contact") {
            return false
        }
        if (!recipient?.marketingPreferences) {
            const existingMP = contactStore.tableState.data.find((contact: Contact) =>
                contact.emails.some((email) => email.emailAddress === (recipient.email as unknown as string))
            )
            if (!existingMP) {
                return false
            }
        }

        return (
            (!recipient?.marketingPreferences?.isEnabledMessageManual && props.type === "sms") ||
            (!recipient?.marketingPreferences?.isEnabledEmailManual && props.type === "email")
        )
    })
)

function setSendAnyway() {
    const recipients = props.recipients as Array<Contact>
    contactStore.haveAllMP = recipients.every((recipient: Contact) => {
        if (recipient?.type !== "contact") {
            return false
        }
        const { marketingPreferences } = recipient || {}
        if (!marketingPreferences) {
            const existingMP = contactStore.tableState.data.find((item) =>
                item.emails.some((email) => email.emailAddress === (recipient.email as unknown as string))
            )?.marketingPreferences
            if (!existingMP) {
                return false
            }
        }
        return (
            (!marketingPreferences?.isEnabledMessageManual && props.type === "sms") ||
            (!marketingPreferences?.isEnabledEmailManual && props.type === "email")
        )
    })
}

watch(
    () => props.recipients,
    () => setSendAnyway(),
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (hasMP.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(MarketingPreferencesIcon, { class: "w-4 h-4" }),
          _createElementVNode("p", null, [
            (_ctx.recipients.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Some contacts have"))
              : (_ctx.showContactName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.recipients[0].fullName || `${_ctx.recipients[0].firstName} ${_ctx.recipients[0].lastName}`), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(" has"))
                  ]))
                : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(text.value), 1)
          ])
        ]),
        (_ctx.showCheckbox)
          ? (_openBlock(), _createBlock(GgmsCheckBox, {
              key: 0,
              modelValue: _unref(contactStore).sendAnywayMP,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(contactStore).sendAnywayMP) = $event)),
              label: "Send anyway",
              onChange: setSendAnyway
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})